import React from 'react'

const SectionOne = (props) => {
    const {handleButtonClick ,setSelectedOptions ,selectedOptions,toggleOption ,setMessageBoard,setErrorTabEnable} = props
    return (
        <>
            <div style={{ paddingTop: "0px" }} className="error-message-head1">
                Check The Error Message
            </div>
            <div className="error-message-head2">
                Request subscriber to read the message on his/her screen
            </div>
            <div className="error-message-head2">
                If subscriber confirms that the message is “No Signal”
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        handleButtonClick(1, "yes");
                        setSelectedOptions([
                            true,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                        ]);
                    }}
                    disabled={selectedOptions[1]}
                    className={`error-button ${toggleOption[1] === "yes" ? "clicked" : ""
                        }`}
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        handleButtonClick(1, "no");
                        setMessageBoard(false);
                        setErrorTabEnable(false);
                    }}
                    className={`error-button ${toggleOption[1] === "no" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[1]}
                >
                    No
                </button>
            </div>
            <div className="error-message-head2">
                Ascertain if the “No Signal” message is related to TV or from TataPlay
                (Ask subscriber to read the whole message)
            </div>
            <div className="error-message-head2">
                {" "}
                TV related “No Signal” is due to the right input source not selected
                on TV Remote i.e., AV,AV1,AV2 or HDMI - Ask Subscriber to select the
                right input
            </div>
            <div className="error-message-head2">
                TataPlay related “No Signal” - Continue with Troubleshooting Steps
            </div>
        </>
    )
}

export default SectionOne
